const customEmojiAssets = import.meta.glob('../../assets/custom-emojis/*.png', {
  eager: true,
  import: 'default',
});

export default customEmojiAssets;
